<template>
  <div>
    <div class="d-flex participant-date-picker">
      <select name="date" id="date" :disabled="answer && answer.isDisabled" v-model="updatedAns.date" class="participant-date-picker__dropdown participant-date-picker__dropdown-date p-5 col-4" @change="onDateChange" :class="{ 'participant-date-picker__dropdown-error': !isDateValid }">
        <option v-for="date in 31" :key="date" :value="date">{{ date }}</option>
      </select>

      <select name="month" id="month" :disabled="answer && answer.isDisabled" v-model="updatedAns.month" class="ml-4 participant-date-picker__dropdown participant-date-picker__dropdown-month p-3 col-4" @change="onDateChange" :class="{ 'participant-date-picker__dropdown-error': !isDateValid }">
        <option v-for="(month, index) in months" :key="month" :value="index">{{ month }}</option>
      </select>

      <select name="month" id="month" :disabled="answer && answer.isDisabled" v-model="updatedAns.year" class="ml-4 participant-date-picker__dropdown participant-date-picker__dropdown-year p-5 col-4" @change="onDateChange" :class="{ 'participant-date-picker__dropdown-error': !isDateValid }">
        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
      </select>
    </div>
    <span class="d-block text-danger mt-5" v-if="isDisplayErrorMessage && !isDateValid">Please enter valid date</span>
    <span class="d-block text-danger mt-5" v-else-if="isDisplayWarningMessage && !isDateValid">Please enter valid date</span>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      years: null,
      isDateValid: true,
      isDisplayWarningMessage: false
    };
  },

  props: {
    updatedAns: Object,
    isDisplayErrorMessage: {
      default: true
    },
    answer: Object
  },

  created() {
    this.getYearsList();
  },

  methods: {
    // get years list ( maintain 1900 as min year, current year + 50 as max year)

    getYearsList() {
      this.years = [];
      const minYear = 1900;
      const maxYear = new Date().getFullYear() + 15;
      for (let year = minYear; year <= maxYear; year++) {
        this.years.push(year);
      }
    },

    checkIsDateValid() {
      const { month, date, year } = this.updatedAns;
      const dateString = `${month + 1}-${date}-${year}`;
      const momentDate = moment(dateString, "MM-DD-YYYY");

      if (momentDate.isValid()) {
        return true;
      }

      return false;
    },

    onDateChange() {
      if (this.checkIsDateValid()) {
        this.isDateValid = true;
        this.$emit("answerChanged", this.updatedAns);
        this.$emit("isDateValid", true);
      } else {
        this.isDateValid = false;
        this.$emit("isDateValid", false);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.participant-date-picker {
  &__dropdown {
    border: 1px solid #bfbfbf;
    border-radius: 4px;
    height: 34px;
    background-color: white;

    &-error {
      border: 1px solid red !important;
    }

    &-date {
      width: 58px;
    }

    &-month {
      width: 142px;
    }

    &-year {
      width: 74px;
    }
  }
}
</style>
